module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="rankings-data">\n	<h1>Top 50 Comps</h1>\n	<p>We restrict the results to the Top 50 Comps.</p>\n</div>\n<div class="table-header">\n	<div class="table-item rank-item" data-order="rank">OVERALL Rank</div>\n	<div class="table-item name" data-order="team_name">comp / commissioner</div>\n	<div class="table-item avatar"></div>\n	<div class="table-item">average tips</div>\n	<div class="table-item">round average</div>\n	<div class="table-item">Avg total margin</div>\n	<div class="table-item">avg round margin </div>\n</div>';
}
return __p;
};
